import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, QueryRenderer } from "react-relay";
import Dendrogram from "./Components/Dendrogram";

import environment from "../../Environment";

const query = graphql`
    query DendrogramContainer_Query {
        elements {
            name
            id
            __typename
            children {
                name
                id
                __typename
                children {
                    name
                    id
                    __typename
                }
            }
        }
    }
`;

export default class DendrogramContainer extends Component {
  static propTypes = {
    quarterCircle: PropTypes.bool,
  };

  static defaultProps = {
    quarterCircle: false
  };

  constructor(props) {
    super(props);
  }

  render() {
    console.log(this.props.query);
    console.log(this.props.query);
    return (
      <div className="w-100">
        <QueryRenderer
          query={query}
          environment={environment}
          variables={{}}
          render={({ error, props }) => {
            if (error) {
              return <div>Error</div>;
            }

            if (!props) {
              return <div>Loading...</div>;
            }

            console.log(props);
            console.log(props.elements);
         


            return <div>
              <Dendrogram data={props.elements} key={this.props.quarterCircle.toString()} quarterCircle={this.props.quarterCircle} />
            </div>;
          }}
        />

      </div>);
  }
}

// <img src={dendroImage} />




// WEBPACK FOOTER //
// ./src/Components/DendrogramContainer/index.js